<template>
    <div class="empty-placeholder">
      <img src="../../assets/empty-chats.png" alt="Нет диалогов" class="empty-image" />
      <h3 class="title">Нет сообщений</h3>
      <p class="subtitle">
        Найдите интересных кандидатов или компании,<br />
        чтобы начать общение!
      </p>
    </div>
  </template>
  
  <script setup>
  </script>
  
  <style scoped>

.empty-placeholder {
  width: 100%;
  height: 100%;
  min-height: 300px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0px;
  text-align: center;
}
  
.empty-image {
  margin-top: -300px;
  width: 120px;
  height: 120px;
  object-fit: contain;
  margin-bottom: 20px;
}

  .title {
    font-size: 18px;
    font-family: "Eastman-Bold", sans-serif;
    color: var(--text-primary);
    margin-bottom: 8px;
    letter-spacing: -0.5px;
  }
  
  .subtitle {
    font-size: 12px;
    font-family: "Eastman-Regular", sans-serif;
    color: #797979;
    line-height: 1.4;
  }

@media (max-width: 430px) {

  .empty-placeholder {
    min-height: calc(100vh - 240px);
    padding: 16px 20px 40px;
    justify-content: center;
  }

  .empty-image {
    margin-top: -20px;
    width: 78px;
    height: 78px;
    margin-bottom: 14px;
    opacity: 0.95;
  }

  .title {
    font-size: 18px;
    margin-bottom: 6px;
    line-height: 1.05;
  }

  .subtitle {
    font-size: 13px;
    line-height: 1.4;
    max-width: 240px;
  }

}
  
  </style>